<template lang="html">
  <b-form class="sticky-top">
    <b-form-row>
      <b-col cols="6">
        <b-form-group>
          <Chosen placeholder="[ALL]" :multiple="true" name="select-reportingPeriod" :options="filterValues.reportingPeriods" id="reportingPeriods" :value="filter.reportingPeriod" v-model="filter.reportingPeriod">
            <label slot="label">Reporting Period</label>
          </Chosen>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group>
          <Chosen placeholder="[ALL]" :multiple="true" name="select-publishedDate" :options="filterValues.publishedDates" id="publishedDates" :value="filter.publishedDate" v-model="filter.publishedDate">
            <label slot="label">Published Date</label>
          </Chosen>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="6">
        <b-form-group>
          <Chosen placeholder="[ALL]" :multiple="true" name="select-caseNumber" :options="filterValues.caseNumbers" id="caseNumbers" :value="filter.number" v-model="filter.number">
            <label slot="label">Case Number</label>
          </Chosen>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group>
          <Chosen placeholder="[ALL]" :multiple="true" name="select-caseType" :options="filterValues.caseTypes" id="caseTypes" :value="filter.caseType" v-model="filter.caseType">
            <label slot="label">Case Type</label>
          </Chosen>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="6">
        <b-form-group>
          <Chosen placeholder="[ALL]" :multiple="true" name="select-division" :options="filterValues.divisions" id="division" :value="filter.division" v-model="filter.division">
            <label slot="label">Division or Mission</label>
          </Chosen>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group>
          <Chosen :multiple="true" placeholder="[ALL]" name="select-region" :options="filterValues.regions" id="region" :value="filter.region" v-model="filter.region">
            <label slot="label">Region</label>
          </Chosen>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="6">
        <b-form-group>
          <Chosen :multiple="true" name="select-allegations" placeholder="[ALL]" :options="filterValues.allegations" id="allegations" :value="filter.allegations" v-model="filter.allegations">
            <label slot="label">Allegation</label>
          </Chosen>
        </b-form-group>
      </b-col>
        <b-col cols="6">
          <b-form-group>
            <Chosen :multiple="true" placeholder="[ALL]" name="select-findings" :options="filterValues.findings" id="findings" :value="filter.findings" v-model="filter.findings">
            <label slot="label">Finding</label>
          </Chosen>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="6">
        <b-form-group>
          <Chosen :multiple="true" placeholder="[ALL]" name="select-penalties" :options="filterValues.penalties" id="penalties" :value="filter.penalties" v-model="filter.penalties">
              <label slot="label">Penalty</label>
            </Chosen>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group>
          <Chosen :multiple="true" placeholder="[ALL]" name="overallRating" :options="filterValues.overallRatings" id="overallRating" :value="filter.overallRating" v-model="filter.overallRating">
            <label slot="label">Case Rating</label>
          </Chosen>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row class="mt-3">
    <b-col cols="6">
      <b-form-group id="startDate" label="Incident Start Date" label-for="text-startDate">
        <datepicker input-class="datePicker" :bootstrap-styling="true" :format="dateFormat" :clear-button="true" id="text-startDate" v-model="filter.startDate" />
      </b-form-group>
    </b-col>
      <b-col cols="6">
        <b-form-group id="endDate" label="Incident End Date" label-for="text-endDate">
          <datepicker input-class="datePicker" :bootstrap-styling="true" :clear-button="true" :format="dateFormat" id="text-endDate" v-model="filter.endDate" />
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-button @click="resetFilter" class="reset-button" size="sm">Reset Filters</b-button>
      </b-col>
      <b-col class="pt-1 filteredCasesLabel">
        <p class="text-center font-italic">Filtered Cases: {{cases.length}}</p>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import Chosen from '@/components/Chosen.vue'
import $ from 'jquery'
export default {
  components: {
    Datepicker,
    Chosen
  },
  props: [
    'cases'
  ],
  data() {
    return {
      monthNames: ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ],
      filter: {
        allegations: [],
        findings: [],
        penalties: [],
        division: [],
        caseType: [],
        region: [],
        startDate: null,
        endDate: null,
        reportingPeriod: [],
        overallRating: [],
        publishedDate: [],
        number: [],
        suffix: ['INQ', 'INV']
      }
    }
  },
  computed: {
    currentPublishedDate() {
      let today = new Date()
      let month = today.getUTCMonth()
      let year = today.getUTCFullYear()
      return [this.monthNames[month] + '/' + year]
    },
    filterValues() {
      return this.$store.getters['scmu/filterValues']
    }
  },
  mounted() {
    if (typeof this.$route.query.caseNumber !== 'undefined' && this.$route.query.caseNumber.length > 0) {
      this.filter.number = [this.$route.query.caseNumber]
      this.filter.publishedDate = []
    } else if (this.filterValues !== null && this.filterValues.publishedDates !== undefined && this.filterValues.publishedDates.length > 0) {
      this.filter.publishedDate = typeof this.filterValues.publishedDates[0] !== 'undefined' ? [this.filterValues.publishedDates[0].value] : []
    }
  },
  watch: {
    filter: {
      handler() {
        this.$emit('applyFilter', this.filter)
      },
      deep: true
    },
    filterValues: function () {
      if (this.filter.number.length < 1) {
        this.filter.publishedDate = typeof this.filterValues.publishedDates[0] !== 'undefined' ? [this.filterValues.publishedDates[0].value] : []
      }
    }
  },
  methods: {
    compareCaseNumbers(a, b) {
      if (parseInt(a.value.split('-')[1]) > parseInt(b.value.split('-')[1])) return 1
      if (parseInt(b.value.split('-')[1]) > parseInt(a.value.split('-')[1])) return -1
      return 0
    },
    dateFormat(date) {
      date = new Date(date)
      date = new Date((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear())
      return date.toLocaleDateString('en-US')
    },
    resetFilter() {
      this.filter = {
        allegations: [],
        findings: [],
        penalties: [],
        division: [],
        caseType: [],
        region: [],
        startDate: null,
        endDate: null,
        reportingPeriod: [],
        overallRating: [],
        publishedDate: [this.filterValues.publishedDates[0].value],
        number: [],
        suffix: ['INQ', 'INV']
      }
      $('.chosen-select')
        .trigger('chosen:updated')
    }
  }
}
</script>
<style scoped>
* {
  font-family: Nunito, freight-sans-pro, Sans Source;
}
</style>
<style lang="css">

.filteredCasesLabel {
font-size: 0.7rem;
}

.btn.reset-button {
font-size: 0.7rem;
padding: 2%;
-webkit-border-radius: 0.2rem;
border-radius: 0.2rem
}
.filter {
border-right: 0.1rem solid black;
}

.datePicker {
background-color: white !important;
border: 1px solid #ced4da !important;

}

.vdp-datepicker .input-group-text {
border-radius:  0 .25rem .25rem 0   !important;
}

span.input-group-text,
.vdp-datepicker__calendar {
font-size: 0.5rem;
}
form p {
margin-top: 0;
margin-bottom: 1rem;
}
.custom-select {

}

.form-group label,
.custom-select,
.datePicker {
font-size: 0.5rem !important;
}
</style>
